import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { StatsStrip } from "@/components/StatsStrip";
import { Manifesto } from "@/components/Manifesto";
import { ProductExplorer } from "@/components/ProductExplorer";
import { Markets } from "@/components/Markets";
import { Founder } from "@/components/Founder";
import { EditorialMarquee } from "@/components/EditorialMarquee";
import { EnquiryFooter } from "@/components/EnquiryFooter";

export default function Landing() {
  return (
    <main className="bg-white text-vw-ink antialiased">
      <Navbar />
      <Hero />
      <StatsStrip />
      <Manifesto />
      <ProductExplorer />
      <Markets />
      <Founder />
      <EditorialMarquee />
      <EnquiryFooter />
    </main>
  );
}
